import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b1c7b39"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = { id: "titleContainer" }
const _hoisted_3 = { id: "test-review-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TestReview = _resolveComponent("TestReview")!
  const _component_NavigationFooter = _resolveComponent("NavigationFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _createElementVNode("b", null, _toDisplayString(_ctx.getTitle()), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_TestReview, {
        "test-part": _ctx.testController?.test?.testParts[0],
        "display-items": _ctx.testController?.navigationController?.getDisplayItems(),
        "display-as-screen": true,
        "is-test-end-review": _ctx.isTestEndReview(),
        "section-lock-enabled": _ctx.sectionLockEnabled(),
        "flag-item-enabled": _ctx.flagItemEnabled()
      }, null, 8, ["test-part", "display-items", "is-test-end-review", "section-lock-enabled", "flag-item-enabled"])
    ]),
    _createVNode(_component_NavigationFooter, {
      id: "navigation-footer",
      "previous-button-text": _ctx.getPreviousButtonText(),
      "next-button-text": _ctx.getNextButtonText(),
      "use-submit-icon": _ctx.useSubmitIconWithNextButton()
    }, null, 8, ["previous-button-text", "next-button-text", "use-submit-icon"])
  ]))
}